module.exports = __webpack_public_path__ + "img/business-title.da397831.png";